import { useState } from "react";
import { FaPauseCircle } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { setScheduledPause } from "src/store/auth/reducer";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import Swal from "sweetalert2";

type BottomBannersProps = {
  isRecording: boolean;
};

export default function BottomBanners({ isRecording }: BottomBannersProps) {
  const { scheduledPause } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const [scheduledPauseVisible, setScheduledPauseVisible] = useState(true);

  const handleCancelScheduledPause = async () => {
    const result = await Swal.fire({
      title: "Cancelamento de pausa agendada",
      html: `Deseja remover a pausa agendada para após este atendimento?`,
      confirmButtonText: "Confirmar cancelamento",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      dispatch(setScheduledPause(null));
      setScheduledPauseVisible(true);
    }
  };

  return (
    <div className="absolute left-0 bottom-0 flex z-99">
      {isRecording && <div className={`is-recording-label bg-feedback-negative-500 text-white font-bold py-3 px-4 ${!scheduledPause && "rounded-tr-lg"}`}>Gravando</div>}

      {scheduledPause && scheduledPauseVisible && (
        <div className="flex gap-4 items-center bg-[#FFEFB2] text-[#5B5A6C] text-xs px-3.25 py-2 rounded-r-xs rounded-bl-xs">
          <div className="flex items-center gap-2">
            <FaPauseCircle size={15} /> <span className="text-[#38394D]">Pausa agendada</span>
          </div>

          <button type="button" className="hover:text-red-900" onClick={handleCancelScheduledPause}>
            Cancelar
          </button>
          <button type="button" className="hover:text-red-900" onClick={() => setScheduledPauseVisible(false)}>
            <FaXmark />
          </button>
        </div>
      )}
    </div>
  );
}
